import React from 'react';
import { Check } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import BreadcrumbSchema from '../components/BreadcrumbSchema';

const featureGroups = [
  {
    title: 'AI Highlight Detection',
    items: [
      'Audio, sentiment, and visual scoring in one timeline',
      'Speech-aware keyword search',
      'Confidence scoring with manual overrides',
    ],
  },
  {
    title: 'Smart Exporter',
    items: [
      'One-click outputs for TikTok, Shorts, Reels, and YouTube',
      'Caption templates with brand fonts and colors',
      'Multi-ratio exports (9:16, 1:1, 16:9) simultaneously',
    ],
  },
  {
    title: 'Collaboration',
    items: [
      'Guest review links with timestamped comments',
      'Version history for every clip',
      'Shared media library and templates',
    ],
  },
];

const Features: React.FC = () => {
  return (
    <>
      <SEOHead
        title="ClipThis Features"
        description="Explore the AI-powered features that make ClipThis the fastest way to turn long videos into viral clips."
        url="/features"
      />
      <BreadcrumbSchema
        items={[
          { name: 'Features', path: '/features' },
        ]}
      />
      <div className="relative overflow-hidden bg-white">
        <div className="absolute inset-0 dot-pattern-animated opacity-30 pointer-events-none" />
        <section className="relative z-10 max-w-5xl mx-auto px-6 py-16 animate-fade-up">
          <p className="text-red-600 uppercase tracking-[0.3em] text-xs mb-3">Features</p>
          <h1 className="text-4xl font-display font-bold text-gray-900 mb-6">Designed for modern content teams</h1>
          <p className="text-lg text-gray-600 mb-10">
            ClipThis combines AI detection with human-friendly controls so you can review, refine, and export clips without leaving the browser.
          </p>
          <div className="grid md:grid-cols-3 gap-6">
            {featureGroups.map((group) => (
              <div key={group.title} className="p-6 rounded-2xl border border-gray-200 bg-gray-50">
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">{group.title}</h2>
                <ul className="space-y-3">
                  {group.items.map((item) => (
                    <li key={item} className="flex items-start space-x-3">
                      <Check className="h-5 w-5 text-red-600 mt-1" />
                      <span className="text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default Features;

